
export const reducerModuleSetBasicData = (state, module) => {
    //TODO: add validation
    //TODO: set basic info
    return {
        ...state,
        module,
    };
}